<template>
  <div id="editForm">
    <pack-info :packId="packId"></pack-info>
    <v-container fluid>
      <v-row class="och-topMargin--packInfoOffset" justify-center>
        <v-col sm="12" md="11"> <release-note-form mode="edit"></release-note-form> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PackInfo from "@/components/packInfo";
import ReleaseNoteForm from "@/components/releaseNoteForm";

export default {
  name: "releaseNoteEdit",
  components: {
    PackInfo,
    ReleaseNoteForm,
  },
  computed: {
    packId() {
      return this.$route.params.packId;
    },
    releaseNoteId() {
      return this.$route.params.releaseNoteId;
    },
  },
};
</script>
